<div *ngIf="guardian">

<div class="card">
    <h6 class="card-header"> Student Details</h6>
    <div class="card-body">
        <div class="table-responsive-sm">
            <table class="table table-sm table-borderless table-striped">
                <thead>
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Current Level</th>
                    <th>Country</th>
                    <th>Username</th>
                    <th>Mode</th>
                    <th class="text-center"> Passwords</th>
                    <th *ngIf="gatePass.is_role_admin"></th>
                </tr>
             </thead>
             <tbody>
                <tr *ngFor="let student of guardian.students; index as myCount">
                    <td><img src="/assets/images/icons/student_pic_64.png" class="round-image"></td>
                    <td class="align-middle">{{student.fullname}}</td>
                    <td class="text-center align-middle">
                       <a  *ngIf="student.bs.length>0"
                             [routerLink]="['/student/show',student.server_user_id]">
                                Quiz ({{student.level_short_name}})
                        </a>

                    <div *ngIf="student.bs.length==0">
                      <a [routerLink]="['/student/enrollments',student.server_user_id]">
                        <i class='fa fa-plus'></i> Enrol to Class
                      </a>
                    </div>
                    </td>
                    <td class="text-center align-middle">
                        <app-country-flag [countryImage]="student.countryImage"></app-country-flag>
                    </td>
                    <td class="align-middle">{{student.email}}</td>

                    <td class="align-middle">{{student.subscription_object.is_premium ? 'Premium' : 'Trial'}}</td>
                    <td class="text-center align-middle">
                        <a *ngIf="student.bs.length>0" [routerLink]="['/user/password/edit/',student.server_user_id]"
                            class="btn btn-link btn-outline-primary">
                            Edit Login and Passwords
                        </a>
                    </td>

                    <td *ngIf="gatePass.is_role_admin">
                        <fieldset class="buttons">
                            <a [routerLink]="['/home/student/edit' ,student.server_user_id]" class="btn btn-link btn-outline-primary">Edit</a>
                            <button input class="delete">Delete</button>
                        </fieldset>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
</div>
<fieldset class ="text-center" *ngIf="guardian.students.length==0">
    <a  (click)="addStudentRegistrationPopup()"
    class="btn btn-outline-primary btn-lg mt-4 me-2"><i class='fa fa-user-plus'></i> Register New Student
</a>

<a class="btn btn-secondary  btn-lg mt-4 disabled" > -- OR -- </a>
<a  [routerLink]="['/guardian/tour',guardian.server_user_id]"
    class="btn btn-outline-primary  btn-lg mt-4 ml-2">Take a Demo Tour
</a>
<app-register-student [guardian]="guardian"></app-register-student>
</fieldset>
</div>

